<template>
    <div
        v-if="props.text"
        class="caution-text-wrap caption--regular"
        :style="marginStyle"
        v-dompurify-html="props.text ?? ''"
    ></div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
    text?: string | null;
    margin?: string;
}>();

const marginStyle = computed(() => {
    if (props.margin) {
        return {
            margin: props.margin,
        };
    }
    return {};
});
</script>

<style scoped lang="scss">
.caution-text-wrap {
    margin-top: 1.6rem;
    padding: 1.2rem 1.5rem;
    background: $grey-3;
    border-radius: 0.8rem;
    color: $grey-7;
    word-break: keep-all;
}
</style>
